var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 200",
    style: {
      enableBackground: "new 0 0 600 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#635BFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,200H100C45,200,0,155,0,100v0C0,45,45,0,100,0h400c55,0,100,45,100,100v0C600,155,555,200,500,200z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480,102.5c0-25.6-12.4-45.8-36.1-45.8c-23.8,0-38.2,20.2-38.2,45.6c0,30.1,17,45.3,41.4,45.3 c11.9,0,20.9-2.7,27.7-6.5v-20c-6.8,3.4-14.6,5.5-24.5,5.5c-9.7,0-18.3-3.4-19.4-15.2h48.9C479.8,110.1,480,104.9,480,102.5z  M430.6,93c0-11.3,6.9-16,13.2-16c6.1,0,12.6,4.7,12.6,16H430.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.1,56.7c-9.8,0-16.1,4.6-19.6,7.8l-1.3-6.2h-22v116.6l25-5.3l0.1-28.3c3.6,2.6,8.9,6.3,17.7,6.3 c17.9,0,34.2-14.4,34.2-46.1C401.1,72.5,384.6,56.7,367.1,56.7z M361.1,125.6c-5.9,0-9.4-2.1-11.8-4.7l-0.1-37.1 c2.6-2.9,6.2-4.9,11.9-4.9c9.1,0,15.4,10.2,15.4,23.3C376.5,115.6,370.3,125.6,361.1,125.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "289.8,50.8 314.9,45.4 314.9,25.1 289.8,30.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.8,
    y: 58.4,
    className: "st1",
    width: 25.1,
    height: 87.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.9,65.8l-1.6-7.4h-21.6v87.5h25V86.6c5.9-7.7,15.9-6.3,19-5.2v-23C280.5,57.2,268.8,55,262.9,65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.9,36.7l-24.4,5.2l-0.1,80.1c0,14.8,11.1,25.7,25.9,25.7c8.2,0,14.2-1.5,17.5-3.3v-20.3 c-3.2,1.3-19,5.9-19-8.9V79.7h19V58.4h-19L212.9,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,83.8c0-3.9,3.2-5.4,8.5-5.4c7.6,0,17.2,2.3,24.8,6.4V61.3c-8.3-3.3-16.5-4.6-24.8-4.6 C133.5,56.7,120,67.3,120,85c0,27.6,38,23.2,38,35.1c0,4.6-4,6.1-9.6,6.1c-8.3,0-18.9-3.4-27.3-8V142c9.3,4,18.7,5.7,27.3,5.7 c20.8,0,35.1-10.3,35.1-28.2C183.4,89.7,145.3,95,145.3,83.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/st.367a1763a96edbcca55f873d3aaa6071.svg";
export { ForwardRef as ReactComponent };